(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .config(config);

    config.$inject = ['$stateProvider', '$urlRouterProvider'];

    function config($stateProvider, $urlRouterProvider) {
        $urlRouterProvider
            // Check if a service ticket is present in the current url's search parameters.
            .when(/\\*/, ticketHandler)
            // Determine where to reroute the user when they navigate to '/'.
            .when('/', defaultPathRedirect);

        $stateProvider
            .state('accountManagement', {
                templateUrl: 'app/components/accountManagement.view.html',
                controller: 'AccountManagementController',
                controllerAs: 'vm'
            })
            .state('about', {
                url: '/about',
                templateUrl: 'app/components/accountManagement.view.html',
                controller: 'AccountManagementController',
                controllerAs: 'vm'
            });

        ticketHandler.$inject = ['$cookies', '$state', '$modal', 'authentication', '$location', 'Idle', 'config'];

        function ticketHandler($cookies, $state, $modal, authentication, $location, Idle, config) {
            var searchParms = $location.search();

            // Check if a service ticket is present in the current url's search parameters. If not, continue handling route as normal.
            if (angular.isDefined(searchParms.ticket)) {
                var ticket = searchParms.ticket;
                return config.get().then(function (configData) {
                    return authentication.logIn(ticket).then(function (response) {

                        Idle.watch();

                        $cookies.remove('logged-out-reason');

                        var options = {
                            controllerAs: 'vm',
                            backdrop: 'static',
                            keyboard: false
                        };

                        // Check if the user logged in with a one-time password or a password that is soon to expire. If so, display a modal with the appropriate warning.
                        if (response.isOneTimeUsePassword) {
                            options.templateUrl = 'app/components/dashboard/editPassword.view.html';
                            options.controller = 'EditPasswordController';
                            options.resolve = {
                                isDismissible: function () {
                                    return false;
                                }
                            };
                            options.id = 1;
                            $modal.open(options)
                                .result.then(function () {
                                    // Same as dashboard.controller.js - onClickEditPassword()
                                    $cookies.put('logged-out-reason', "Password successfully changed! Please log in again with your new credentials.");

                                    return emailPasswordChangeLogOut();
                                });
                        // If password is near expiration, alert user. If using Common Access Card (CAC), don't bother.
                        // Days to expire field should also not be null if using the modal. (Previously this was the only way to determine CAC use.)
                        } else if (!response.cac_in_use && (response.daysToExpire !== null) && (response.daysToExpire < configData.passwordExpirationWarningDays)) {
                            options.templateUrl = 'app/components/logIn/passwordExpirationModal/passwordExpirationModal.view.html';
                            options.controller = 'PasswordExpirationModalController';
                            options.resolve = {
                                daysRemaining: function () {
                                    return response.daysToExpire;
                                }
                            };
                            options.size = 'tiny';
                            $modal.open(options);
                        }

                        $state.go('accountManagement.dashboard', null, { reload: true });
                    }).catch(function (err) {
                        console.error(err);
                        // Reroute the user to the logged out page and display the appropriate error.
                        $cookies.put('logged-out-reason', configData.loggedOutReasons.ticketError);
                        $state.go('accountManagement.loggedOut', null, { reload: true });
                    });
                });
            }
            return false;

            // Copied from dashboard.controller.js
            // TODO: not DRY
            function emailPasswordChangeLogOut() {
                var ticketErrorStr = "";

                return config.get().then(function (configData) {
                    ticketErrorStr = configData.loggedOutReasons.ticketError;
                })
                    // This function does most of logOut() except not log out of Core API,
                    // since that appears to be done by the API when changing email/password.
                    // This function should change URL, so only failure should return here?
                    .then(authentication.logOutCasOnly)
                    .catch(function (error) {
                        console.error(error);
                        $cookies.put('logged-out-reason', ticketErrorStr);
                    })
                    // This shouldn't happen, but just in case, send to AM logged out page.
                    .finally(function (response) {
                        $state.go('accountManagement.loggedOut');
                    });
            }
        }

        defaultPathRedirect.$inject = ['$cookies', '$state'];

        function defaultPathRedirect($cookies, $state) {
            $state.go('accountManagement.dashboard', null, { reload: true });
        }
    }
})();